import React from 'react';
import PropTypes from 'prop-types';
import styles from './FieldInfo.css';
import { bem } from '../../../../helpers/styles';

function FieldInfo({ content, informationCanWrap = false }) {
  if (content === undefined || content === null) {
    return <div className={styles.FieldInfo}>&nbsp;</div>;
  }
  return <div className={bem(styles, 'FieldInfo', { informationCanWrap })}>{content}</div>;
}

FieldInfo.propTypes = {
  content: PropTypes.string,
  informationCanWrap: PropTypes.bool,
};

export default FieldInfo;
